import {
    ProductContainer,
    ProductHeading ,
    ProductWrapper ,
    ProductCard ,
    ProductImg ,
    ProductInfo ,
    ProductTitle ,
    ProductDesc ,
    ProductPrice ,
    ProductButton ,
} from './ProductsElement'

const Products = ( { Heading , data}) => {
    return (
        <ProductContainer id="home">
            <ProductHeading> { Heading }</ProductHeading>
            <ProductWrapper>
                {data.map((product, index) => {
                    return (
                        <ProductCard key={index}>
                            <ProductImg src={product.img} alt={product.alt} />
                            <ProductInfo>
                                <ProductTitle> { product.name } </ProductTitle>
                                <ProductDesc> { product.desc } </ProductDesc>
                                <ProductPrice> { product.price } </ProductPrice>
                                <ProductButton> { product.button }</ProductButton>
                            </ProductInfo>
                        </ProductCard>
                    )
                })}
            </ProductWrapper>
        </ProductContainer>
    )
}

export default Products
